export interface ContactExpertProps {
  avatarSrc?: string;
  name?: string;
  jobTitle?: string;
  phone?: string;
  email?: string;
}

export const ContactExpert: React.FC<ContactExpertProps> = () => {
  return <></>;
};
